export { default } from './AttemptPerformance';



// WEBPACK FOOTER //
// ./src/components/DataCentre/AttemptPerformance/index.ts